import MonthRangeParent from './monthRangeParent';

export default MonthRangeParent;